<template>
  <div
    style="width:16px;height:16px;"
    v-if="isMine"
  >
    <van-button v-if="this.message.status==='fail'" round icon="replay" type="danger" size="mini" @click="handleIconClick"></van-button>
    <van-button v-if="this.message.status==='unSend'" round loading type="info" size="mini"/>
  </div>
</template>

<script>
export default {
  name: 'MessageStatusIcon',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMine() {
      return this.message.flow === 'out'
    },
  },
  methods: {
    handleIconClick() {//重发
      if (this.message.status === 'fail') {
        this.tim.resendMessage(this.message).catch(imError => {
          this.$toast.fail(imError.message)
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.message-send-fail {
  margin-right: 8px;
  background-color: #f35f5f;
  color: $white;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
}
</style>
